import { render } from "./HtmlLoader.vue?vue&type=template&id=2e51b39c"
import script from "./HtmlLoader.vue?vue&type=script&lang=js"
export * from "./HtmlLoader.vue?vue&type=script&lang=js"

import "./HtmlLoader.vue?vue&type=style&index=0&id=2e51b39c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__